import { FunctionComponent, MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'src/utils/twMerge';
import CornerIconButton from 'src/designSystem/CornerIconButton';
import { CloseIcon } from 'src/designSystem/icons';

type Props = {
  onClick: (event: MouseEvent<HTMLButtonElement>) => void;
  'data-testid'?: string;
  isOnDark?: boolean;
  isDisabled?: boolean;
  className?: string;
};

const CloseButton: FunctionComponent<Props> = ({
  onClick,
  'data-testid': testId,
  isOnDark = false,
  isDisabled = false,
  className,
}) => {
  const { t } = useTranslation();
  return (
    <CornerIconButton
      onClick={onClick}
      isDisabled={isDisabled}
      aria-label={t('global.close')}
      data-testid={testId}
      className={className}
      icon={
        <CloseIcon
          className={twMerge(
            'h-6 w-auto fill-structural-darkest',
            isOnDark && 'fill-white',
          )}
        />
      }
    />
  );
};

export default CloseButton;
